import VideoSpotlight from './video-spotlight'

export default VideoSpotlight
